import { Component, Input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input() label?: string;
  @Input() errorMessages: string[] = [];
  @Input() id?: string;

  public value = false;
  public disabled = false;
  public control?: NgControl;

  onChange: any = () => {};
  onTouched: any = () => {};

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
      this.control = this.ngControl;
    }
  }

  writeValue(value: boolean): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onValueChange(event: boolean): void {
    this.value = event;
    this.onChange(event);
    this.onTouched();
  }

  getValidationNgClasses(): Record<string, boolean> {
    return {
      'ng-invalid': this.control?.invalid ?? false,
      'ng-valid': this.control?.valid ?? false,
      'ng-touched': this.control?.touched ?? false,
      'ng-untouched': !(this.control?.touched ?? false),
      'ng-dirty': this.control?.dirty ?? false,
      'ng-pristine': this.control?.pristine ?? false,
    };
  }
}
